import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTheme } from './theme';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Check for saved preference or system preference
    const getInitialMode = () => {
        const saved = localStorage.getItem('themeMode');
        if (saved) return saved;

        // Check system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
            return 'light';
        }
        return 'dark';
    };

    const [mode, setMode] = useState(getInitialMode);
    const theme = getTheme(mode);

    // Save preference when it changes
    useEffect(() => {
        localStorage.setItem('themeMode', mode);
    }, [mode]);

    const toggleTheme = () => {
        setMode(prev => prev === 'dark' ? 'light' : 'dark');
    };

    const value = {
        mode,
        theme,
        toggleTheme,
        isDark: mode === 'dark',
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export default ThemeContext;
